import React, { FC, HTMLAttributes, ReactElement, RefObject } from "react"
import { ControlProps } from "./Control"
import { SliderHandle } from "./Slider"

interface ControlsProps extends HTMLAttributes<HTMLDivElement> {
    slider: RefObject<SliderHandle>
    className?: string
    children: ReactElement<ControlProps> |  ReactElement<ControlProps>[]
}

export const Controls: FC<ControlsProps> = ({slider, children, className, ...rest}) => {

    return (
        <div className={`controls-container ${className ?? ''}`}>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, { slider })
            })}
        </div>
    )
}